import { Button } from "@mui/material";

export default function BotaoPrincipal(props) {
  return (
    <Button variant="contained" {...props}>
      {props.children}
    </Button>
  );
}
